import { EventTypes, ToastService } from '@ami/angular/core/toasts';
import { AfterViewInit, Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[amiClickToCopy]',
  standalone: true
})
export class CopyLinkDirective implements AfterViewInit {
  @Input() valueToCopy = '';
  @Input() linkClass = 'btn btn-link text-primary ms-2 mb-1 p-0';

  private toastService = inject(ToastService);
  private el = inject(ElementRef<HTMLElement>);
  private renderer = inject(Renderer2);

  private linkElement?: HTMLElement;
  private wrapper?: HTMLElement;
  private originalText = '';

  ngAfterViewInit() {
    // Store the original text before adding the copy link
    this.originalText = this.el.nativeElement.innerText.trim();
    this.createCopyLink();
  }

  private createCopyLink() {
    const host = this.el.nativeElement;

    if (!this.wrapper) {
      // Wrap the original text in a relative container
      const wrapper = this.renderer.createElement('span');
      this.renderer.setStyle(wrapper, 'position', 'relative');
      this.renderer.setStyle(wrapper, 'display', 'inline-block');

      // Move host children into the wrapper
      while (host.firstChild) {
        this.renderer.appendChild(wrapper, host.firstChild);
      }
      this.renderer.appendChild(host, wrapper);
      this.wrapper = wrapper;
    }

    if (!this.linkElement) {
      const link = this.renderer.createElement('button');
      link.className = this.linkClass;
      this.renderer.setStyle(link, 'cursor', 'pointer');
      this.renderer.setStyle(link, 'text-decoration', 'none');

      // Create the icon element
      const icon = this.renderer.createElement('i');
      this.renderer.addClass(icon, 'bi');
      this.renderer.addClass(icon, 'bi-clipboard');
      this.renderer.appendChild(link, icon);

      this.renderer.listen(link, 'click', (event: Event) => {
        event.preventDefault();
        this.copyText();
      });

      this.renderer.appendChild(this.wrapper, link);
      this.linkElement = link;
    }
  }

  private copyText() {
    const text = this.valueToCopy?.trim() || this.originalText;
    if (!text) return;

    navigator.clipboard.writeText(text)
      .then(() => this.toastService.queueToast('Copied', EventTypes.Success))
      .catch(err => console.error('Failed to copy:', err));
  }
}
